module.exports = __webpack_public_path__ + "img/logo.395645b2.svg";